import React, { useState, useEffect } from "react";
import { X, Download } from "lucide-react";
import ApiService from "../../services/Api.service";
import Radio from "../Radio/Radio";

const CampaignCreateModal = ({ item, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    campaign_id: item?.id || "",
    file: null,
    dump_type: "lead_dump"
  });
  const [dragActive, setDragActive] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchDumpTypeOptions = async () => {
      try {
        const res = await ApiService.getUploadDumpTypeOptions();
        if (res && res.data) {
          if (Array.isArray(res.data)) {
            setOptions(res.data);
            if (res.data.length > 0) {
              const hasCurrentValue = res.data.some(opt => opt.value === formData.dump_type);
              if (!hasCurrentValue) {
                setFormData(prev => ({ ...prev, dump_type: res.data[0].value }));
              }
            }
          }
        }
      } catch (error) {
        console.error("Failed to load upload dump type options:", error);
      }
    };
    fetchDumpTypeOptions();
  }, []);

  const handleFileChange = (file) => {
    if (file) {
      setFormData((prev) => ({ ...prev, file }));
    }
  };

  const handleInputChange = (e) => {
    handleFileChange(e.target.files[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFileChange(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
    }
  };

  const handleSave = () => {
    if (!formData.file) {
      alert("Please select a file before saving.");
      return;
    }
    onSave(formData);
  };

  const handleDumpTypeChange = (value) => {
    setFormData((prev) => ({ ...prev, dump_type: value }));
  };

  const handleDownloadSample = async () => {
    try {
        const payload={
        campaign_id:item.id,
        dump_type:formData.dump_type
        }
      const res = await ApiService.getCampaignSampleHeader(payload);
      if (res.status === 200 && res.data.data) {
        const headers = res.data.data.join(",");
        const blob = new Blob([headers], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        const now = new Date();
        const timestamp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
        link.setAttribute("download", `${formData.dump_type}_${timestamp}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading sample file", error);
    }
  };

  return (
    <div className="add-subparam-overlay">
      <div className="add-subparam-modal campaign-modal">
        {/* Header */}
        <div className="add-subparam-header">
          <h3>Upload Data</h3>
          <button onClick={onClose} className="close-btn">
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "1rem" }}>
          {/* Dump Type Selection */}
          <div className="dump-type-section">
            {options.length === 0 ? (
              <div style={{ fontSize: "13px", color: "#6b7280", fontFamily: "Nunito", padding: "8px 0" }}>
                Loading upload options...
              </div>
            ) : (
              <Radio
                name="dump_type"
                label=""
                value={formData.dump_type}
                onChange={handleDumpTypeChange}
                options={options}
              />
            )}
          </div>

          {/* Drag & Drop Upload */}
          <div
            className={`upload-box ${dragActive ? "drag-active" : ""}`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <label htmlFor="file-upload" className="upload-label">
              {formData.file ? (
                <span className="file-selected">
                  Selected File: {formData.file.name}
                </span>
              ) : (
                <>
                  <span>Drag & drop your file here or click to upload </span>
                  <small>Supported Format: .csv</small>
                </>
              )}
            </label>
            <input
              id="file-upload"
              type="file"
              accept=".csv"
              onChange={handleInputChange}
              style={{ display: "none" }}
            />
          </div>

          {/* Download Sample Button */}
          <div className="download-sample">
            <button
              className="download-sample-btn"
              onClick={handleDownloadSample}
              disabled={options.length === 0}
              style={options.length === 0 ? { opacity: 0.5, cursor: "not-allowed" } : {}}
            >
              <Download size={16} /> Download Sample Format
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="add-subparam-footer">
          <button className="popup-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="popup-add-btn"
            onClick={handleSave}
            disabled={options.length === 0}
            style={options.length === 0 ? { opacity: 0.5, cursor: "not-allowed" } : {}}
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};

export default CampaignCreateModal;
